(() => {
  if (window.ryppleCartReviewClock) return;
  window.ryppleCartReviewClock = true;

  const key = 'rypple-cart-review-deadline-v2';
  let deadline = 0;

  function getDeadline() {
    if (deadline) return deadline;
    try {
      deadline = Number(sessionStorage.getItem(key)) || 0;
      if (!deadline) {
        deadline = Date.now() + 10 * 60 * 1000;
        sessionStorage.setItem(key, String(deadline));
      }
    } catch (_) {
      deadline = Date.now() + 10 * 60 * 1000;
    }
    return deadline;
  }

  function update() {
    const timers = document.querySelectorAll('[data-rp-cart-timer]');
    if (!timers.length) return;

    const secondsLeft = Math.max(0, Math.ceil((getDeadline() - Date.now()) / 1000));
    if (secondsLeft === 0) {
      timers.forEach((timer) => timer.remove());
      return;
    }

    const minutes = String(Math.floor(secondsLeft / 60)).padStart(2, '0');
    const seconds = String(secondsLeft % 60).padStart(2, '0');

    timers.forEach((timer) => {
      const clock = timer.querySelector('[data-rp-cart-time]');
      if (!clock) return;
      clock.textContent = `${minutes}:${seconds}`;
    });
  }

  update();
  setInterval(update, 1000);
})();
